import { create } from '@bufbuild/protobuf'
import { useQuery } from '@connectrpc/connect-query'
import { getJepxMemberInfo } from '@ebalance/proto/bffuser/v1/jepx_member_info_service-JepxMemberInfoService_connectquery'
import { GetJepxMemberInfoRequestSchema } from '@ebalance/proto/bffuser/v1/jepx_member_info_service_pb'
import type { Decimal } from '@ebalance/proto/google/type/decimal_pb'

import { resolveFeeUnitPrice } from '~/models/jepxFee'

export type FeeUnitPrices = {
  spot: Decimal | undefined
  intraday: Decimal | undefined
}

/**
 * 入札制限画面「手数料自動考慮」カード (AC-BDL-017 / AC-BDL-020) の OFF 時案内に
 * 使う現在の手数料単価。 SoT は JEPX 会員情報管理 (AC-IJM-007a)、値そのものの
 * 編集・検証は AdminJepxMemberInfo の領分でここでは読み取るだけ。 専用の単価
 * だけを返す RPC は無いため、 会員情報一括取得 (GetJepxMemberInfo) を読む。
 *
 * `throwOnError: false`: QueryClient の既定は throwOnError:true (render 中の
 * throw → router の errorElement で全画面が消える)。 本画面の主目的は入札制限の
 * 設定であり、 会員情報取得の失敗で画面全体を落とさない (`useListTradableAreas`
 * と同じ考え方)。 取得中・取得失敗・JEPX 会員 ID 未登録・未設定のときは undefined
 * (判定は `resolveFeeUnitPrice`)。 整形と「単価なし」の文言への切り替えはカード側で行う。
 */
export function useFeeUnitPrices(): FeeUnitPrices {
  const { data } = useQuery(
    getJepxMemberInfo,
    create(GetJepxMemberInfoRequestSchema, {}),
    { throwOnError: false },
  )
  return {
    spot: resolveFeeUnitPrice(data, 'spot'),
    intraday: resolveFeeUnitPrice(data, 'intraday'),
  }
}
